import * as Graph from 'components/graph';
import { useCallback, useState } from 'react';

import { TimelinePoint } from './TimelineCard';

export type GetClosest = (data: TimelinePoint[]) => TimelinePoint | undefined;

interface UseTooltipPropsResult {
  onHover: (datum?: Graph.Datum) => void;
  getClosest: GetClosest;
}

export const useTooltipProps = (): UseTooltipPropsResult => {
  const [hover, onHover] = useState<Graph.Datum>();

  const getClosest = useCallback<GetClosest>(
    data => {
      if (!hover) {
        return undefined;
      }
      return Graph.getClosestDatum(data)(hover);
    },
    [hover]
  );

  return {
    onHover,
    getClosest,
  };
};
